// extracted by mini-css-extract-plugin
export var articleHeading = "news-module--articleHeading---hyxq";
export var articleQueryContent = "news-module--articleQueryContent--hpFF8";
export var newsButton = "news-module--newsButton--HW7TE";
export var newsSection = "news-module--newsSection--uIyr8";
export var sectionItemNews = "news-module--sectionItemNews--eo57-";
export var sectionLnSpItem = "news-module--sectionLnSpItem--Solm0";